import { render, staticRenderFns } from "./DocumentSignature.vue?vue&type=template&id=5246116d&scoped=true&"
import script from "./DocumentSignature.vue?vue&type=script&lang=js&"
export * from "./DocumentSignature.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSignature.vue?vue&type=style&index=0&id=5246116d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5246116d",
  null
  
)

export default component.exports